import React, { Component } from "react";
import { Modal, DatePicker, message, Select } from "antd";
import axios from "services/axios";
import _ from "lodash";

const { Option } = Select;

class ModalDownload extends Component {
  state = {
    isLoading: false,
    branches: [],
  };

  componentDidMount() {
    this.fetchBranch();
  }

  onCancel() {
    this.props.visibleModal(false);
  }

  async fetchBranch() {
    const {
      data: { branches },
    } = await axios.get(`/misc/branches`);
    this.setState({ branches });
  }

  render() {
    return (
      <Modal
        title={`Download User - ${this.props.role}`}
        visible={this.props.visible}
        onCancel={() => this.onCancel()}
        onOk={() => this.props.downloadData()}
        confirmLoading={this.props.isLoading}>
        {["sales", "branch-head", "tnt", "supervisor"].includes(
          this.props.role
        ) && (
          <div>
            <p>Pilih cabang</p>
            <Select
              defaultValue={this.props.branch}
              style={{ marginBottom: 10 }}
              showSearch
              optionFilterProp="children"
              onChange={(branch) => this.props.onChangeFilter("branch", branch)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }>
              <Option key={0} value={null}>
                Semua Cabang
              </Option>
              {this.state.branches.map((branch, index) => (
                <Option key={index} value={branch.branch}>
                  {branch.branch}
                </Option>
              ))}
            </Select>
          </div>
        )}

        <p>Pilih Status</p>
        <Select
          showSearch
          optionFilterProp="children"
          onChange={(status) => this.props.onChangeFilter("status", status)}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }>
          <Option key={0} value={null}>
            Semua Status
          </Option>
          {["ACTIVE", "DELETED"].map((status, index) => (
            <Option key={index} value={status}>
              {status}
            </Option>
          ))}
        </Select>
      </Modal>
    );
  }
}

export default ModalDownload;



// WEBPACK FOOTER //
// src/components/Dashboard/User/Modal/ModalDownload.js